<template>
    <transition appear
                enter-active-class="animated fadeIn u-anim-dur-500"
                leave-active-class="animated fadeOut u-anim-dur-500">
        <article v-if="messages.length"
                 class="fixed top-0 w-full z-errorToaster"
                 aria-live="assertive"
                 role="alert">
            <div v-for="message in messages"
                 :key="`${message.errorId || message.message}-${message.messageType}`"
                 class="text-white p-30 font-medium text-16 flex w-full items-center justify-between border border-white"
                 :class="getBgColor(message.messageType)">
                <p>
                    {{ getMessage(message) }}
                    <template v-if="message.errorId">
                        [{{ message.errorId }}]
                    </template>
                </p>
                <button class="pl-30" type="button" @click="clearMessage(message)">
                    <CIcon name="close" height="18" width="18" class="text-white"/>
                </button>
            </div>
        </article>
    </transition>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import {
    ValidationMessageType,
    ClientMessageWithError,
    GeneralErrorEventKey,
    ValidationMessageWithErrorType
} from '@/core/messages/types';
import bus from '@/core/bus';
import dictionaryService from '@/core/translation/dictionary.service';
import { ValidationMessage } from '@/types/apiServerContract';

const AUTO_KILL_TIME = 10000; // ms.

const messages = ref<ValidationMessageWithErrorType[]>([]);

function getBgColor(messageType?: ValidationMessageType): string {
    switch (messageType) {
        case ValidationMessageType.Info:
            return 'bg-green-500';
        case ValidationMessageType.Warning:
            return 'bg-yellow-500';
        case ValidationMessageType.Error:
        default:
            return 'bg-red-500';
    }
}

function getMessage(msgOrLabel: ValidationMessageWithErrorType): string {
    if (dictionaryService.exists(msgOrLabel.message)) {
        return dictionaryService.get(msgOrLabel.message, msgOrLabel.messageParameters || []);
    }
    return msgOrLabel.message;
}

function addMessages(clientMessages: ClientMessageWithError): void {
    clientMessages.messages.forEach(msg => {
        msg.errorId = clientMessages.errorId;
        setTimeout(() => clearMessage(msg), AUTO_KILL_TIME);
    });

    messages.value = messages.value.concat(clientMessages.messages);
}

function clearMessage(msg: ValidationMessage): void {
    messages.value = messages.value.filter(m => m !== msg);
}

bus.on(GeneralErrorEventKey, addMessages);
</script>
